import { Button } from '@highlight/ui'
import { ViewConfirmScrim } from '../view-confirm-scrim'

interface DeleteConfirmationProps {
  isOpen: boolean
  onCancel: (e: React.MouseEvent) => void
  onConfirm: (e: React.MouseEvent) => void
  confirmationText?: string
  confirmLabel?: string
}

export function DeleteConfirmation({
  isOpen,
  onCancel,
  onConfirm,
  confirmationText = 'Are you sure you want to delete this item?',
  confirmLabel = 'Delete',
}: DeleteConfirmationProps) {
  return (
    <ViewConfirmScrim isOpen={isOpen} onCancel={onCancel} className="corner-smooth space-y-4 rounded-lg p-2">
      <p className="text-foreground my-0 px-2 pt-2">{confirmationText}</p>
      <div className="flex items-center gap-1.5">
        <Button variant="outline" onClick={onCancel} className="w-full">
          Cancel
        </Button>
        <Button variant="primary" tone="danger" onClick={onConfirm} className="w-full">
          {confirmLabel}
        </Button>
      </div>
    </ViewConfirmScrim>
  )
}
